import React from 'react';
import { useSelector } from 'react-redux';

import { isGoalieOnly, isShiftsOnly, userIsClientFeatureMask } from 'selectors/user/user-features-selector';
import { isStaging } from 'utils/helpers/envirioment-utils';
import SafeMarkdown from 'components/safe-markdown';

import { useFetchNotification } from '../hooks/use-fetch-notification';

import { NotificationBarContainer } from './notification-banner.styled.js';
import { isAvailableForClients, isAvailableForPlayers, isBannerForEnvironment } from './notification-banner-utils';

export const NotificationBar = () => {
    const hasClientRole = useSelector(userIsClientFeatureMask);

    const shiftsOnly = useSelector(isShiftsOnly);
    const isGoalie = useSelector(isGoalieOnly);

    const isStage = isStaging();

    const { notification, showMask, isDisabled } = useFetchNotification({ staging: isStage });

    if (isDisabled) {
        return null;
    }

    const shouldShowToClient = Boolean(isAvailableForClients(showMask) && hasClientRole);
    const shouldShowToPlayer = Boolean(isAvailableForPlayers(showMask) && (shiftsOnly || isGoalie));

    if (!isBannerForEnvironment(showMask, isStage) || !(shouldShowToClient || shouldShowToPlayer)) {
        return null;
    }

    return (
        <NotificationBarContainer>
            <SafeMarkdown>{notification}</SafeMarkdown>
        </NotificationBarContainer>
    );
};
